// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Qy6-","productName":"Table_productName__3xQYc"};